// extracted by mini-css-extract-plugin
module.exports = {"Wysiwyg":"styles_Wysiwyg__uirR1"};